import React from "react";
import { ConfigProvider } from "antd";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import viVn from "antd/locale/vi_VN";
import "./index.scss";
import { createRoot } from "react-dom/client";
import App from "./App";
import store from "redux/store";
const container = document.getElementById("root")!;
const root = createRoot(container);
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.tz.setDefault("Asia/Bangkok");
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "rgba(0, 179, 53, 1)",
          },
        }}
        locale={viVn}
      >
        <App />
      </ConfigProvider>
    </BrowserRouter>
  </Provider>
);
